import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { StartBrowserDownload } from "../../../helper/ui/methods";

export const FileDownload = {
  Download: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const fileDownloadData = state.data;
      const url = "./php/common/downloader-proxy.php";
      await axios
        .post(url, fileDownloadData)
        .then((response) => {
          // The server answers with a presigned Wasabi URL rather than the file
          // itself, so the bytes never pass through digitalcharcoal.io.
          if (response.data.header === "download") {
            StartBrowserDownload(response.data.url);
            serverResponse = "";
          } else {
            serverResponse = response.data;
          }
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }

    return serverResponse;
  },
};
